module.exports = __webpack_public_path__ + "static/Rosewater7-4ad957c1af8013675f722daf518c5646.png";